<template>
  <v-container>
    <v-row>
      <v-col>
        <v-alert type="warning">
          Not Implemented
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
};
</script>
